module.exports = __webpack_public_path__ + "static/media/startSlider.6b3296a0.png";